import React, { useState } from 'react';
import './Showcase.css';

import badge1 from '../../assets/badges/badge1.png';
import badge2 from '../../assets/badges/badge2.png';
import badge3 from '../../assets/badges/badge3.png';
import badge4 from '../../assets/badges/badge4.png';
import badge5 from '../../assets/badges/badge5.png';
import badge6 from '../../assets/badges/badge6.png';
import badge7 from '../../assets/badges/badge7.png';
import badge8 from '../../assets/badges/badge8.png';
import badge9 from '../../assets/badges/badge9.png';
import badge10 from '../../assets/badges/badge10.png';
import badge11 from '../../assets/badges/badge11.png';
import badge12 from '../../assets/badges/badge12.png';
import badge13 from '../../assets/badges/badge13.png';
import badge14 from '../../assets/badges/badge14.png';
import badge15 from '../../assets/badges/badge15.png';
import badge16 from '../../assets/badges/badge16.png';
import badge17 from '../../assets/badges/badge17.png';
import badge18 from '../../assets/badges/badge18.png';
import badge19 from '../../assets/badges/badge19.png';
import badge20 from '../../assets/badges/badge20.png';

import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer
} from 'recharts';

const badgeImages = [
  badge1, badge2, badge3, badge4, badge5,
  badge6, badge7, badge8, badge9, badge10,
  badge11, badge12, badge13, badge14, badge15,
  badge16, badge17, badge18, badge19, badge20
];

const leetcodeData = [
  { contest: 'C1', rating: 1494 },
  { contest: 'C2', rating: 1517 },
  { contest: 'C3', rating: 1539 },
  { contest: 'C4', rating: 1566 },
  { contest: 'C5', rating: 1615 },
  { contest: 'C6', rating: 1649 },
  { contest: 'C7', rating: 1737 },
  { contest: 'C8', rating: 1780 },
];

const codeforcesData = [
  { contest: 'C1', rating: 361 },
  { contest: 'C2', rating: 609 },
  { contest: 'C3', rating: 860 },
  { contest: 'C4', rating: 973 },
  { contest: 'C5', rating: 1033 },
  { contest: 'C6', rating: 1049 },
  { contest: 'C7', rating: 1125 },
  { contest: 'C8', rating: 1215 },
];

const Showcase = () => {
  const [hovered, setHovered] = useState(null);
  const [active, setActive] = useState(null);

  const toggleSection = (section) => {
    setActive(active === section ? null : section);
  };

  return (
    <section id="showcase">
      <h2 className="showcase-heading">SHOWCASE.</h2>

      <div className="pill-container">
        <div
          className={`showcase-pill ${active === 'leetcode' ? 'active' : ''}`}
          onMouseEnter={() => setHovered('leetcode')}
          onMouseLeave={() => setHovered(null)}
          onClick={() => toggleSection('leetcode')}
        >
          LEETCODE
        </div>

        <div
          className={`showcase-pill ${active === 'codeforces' ? 'active' : ''}`}
          onMouseEnter={() => setHovered('codeforces')}
          onMouseLeave={() => setHovered(null)}
          onClick={() => toggleSection('codeforces')}
        >
          CODEFORCES
        </div>
      </div>

      {hovered === 'leetcode' && !active && (
        <p className="showcase-subheading">
          1000+ Questions Solved • Top 8% • Global Rank: 24,000 / 700,000 • Rating: 1780 • Min Rank: 674
        </p>
      )}

      {hovered === 'codeforces' && !active && (
        <p className="showcase-subheading">
          Pupil Rank • Multiple Rated Contests • Peak Rating: 1215
        </p>
      )}

      {active === 'leetcode' && (
        <div className="leetcode-section">
            <p className="showcase-subheading">
          1000+ Questions Solved • Top 8% • Global Rank: 24,000 / 70M • Rating: 1780 • Min Rank: 674
        </p>
          <div className="badge-grid">
            {badgeImages.map((src, idx) => (
              <div className="badge-card" key={idx}>
                <img src={src} alt={`badge-${idx + 1}`} className="badge-img" />
              </div>
            ))}
          </div>

          <div className="chart-wrapper">
            <h4>LeetCode Contest Rating Progress</h4>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={leetcodeData}>
                <XAxis dataKey="contest" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="rating" stroke="#ffa500" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {active === 'codeforces' && (
        <div className="cf-section">
            <p className="showcase-subheading">
          Pupil Rank • Multiple Rated Contests • Peak Rating: 1215
        </p>
          <div className="chart-wrapper">
            <h4>Codeforces Rating Progress</h4>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={codeforcesData}>
                <XAxis dataKey="contest" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="rating" stroke="#00e5ff" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </section>
  );
};

export default Showcase;
